import { Injectable } from '@angular/core';
import { TicketResponse } from '../entity/TicketResponse';
import { catchError, Observable, of, retry, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Ticket } from '../entity/Ticket';
import { TicketValidationStatus } from '../entity/TicketValidationStatus';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TicketSaleService {

  constructor(private http: HttpClient) { }

  public sellTicket(ticket: Ticket): Observable<TicketResponse> {

    return this.http.post<TicketResponse>(environment.HOST+environment.API_PATH_PREFIX+'sell-ticket/'+ticket.validity_token, {
      observe: 'response'
    }).pipe(
      retry(environment.API_RETRY),
      tap((response: TicketResponse) => {
        if(response){
          response.status = TicketValidationStatus.SUCCESS;
        }
        return response;
      }),
      catchError((error) => {
        error.error.status = [400, 423].includes(error.status)? TicketValidationStatus.WARNING : TicketValidationStatus.ERROR;
        return of(error.error);
      })
    );

  }

}
